export const REQUIRED_LAND_DOCUMENTS = [
  { key: "registry", label: "Registry" },
  { key: "jamabandi", label: "Jamabandi" },
  { key: "khatiyan", label: "Khatiyan" },
  { key: "mutation", label: "Mutation" },
  { key: "khasra", label: "Khasra" },
  { key: "survey_number", label: "Survey No." },
  { key: "ownership_proof", label: "Ownership Proof" },
  { key: "tax_receipt", label: "Tax Receipt" },
];

export function prettyLabel(value) {
  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase());
}

export function isLandCategory(category) {
  return ["LAND", "PLOT"].includes(String(category || "").toUpperCase());
}

export function getDocumentKeys(property = {}) {
  const docs = property.documents || property.property_documents || [];
  if (Array.isArray(docs)) {
    return docs.map((d) => String(d.document_type || d.type || d.key || "").toLowerCase()).filter(Boolean);
  }
  if (typeof docs === "object") return Object.keys(docs).map((k) => k.toLowerCase());
  return [];
}

export function missingRequiredDocs(property = {}) {
  if (!isLandCategory(property.category)) return [];
  const uploaded = new Set(getDocumentKeys(property));
  return REQUIRED_LAND_DOCUMENTS.filter((doc) => !uploaded.has(doc.key));
}

export function verificationBadges(property = {}) {
  const status = propertyStatus(property.status);
  return [
    { key: "owner", label: "Verified Owner", ok: !!property.verified_owner },
    { key: "docs", label: "Verified Documents", ok: !!property.verified_documents },
    { key: "office", label: "Office Checked", ok: ["VERIFIED", "PUBLISHED", "BOOKED", "PENDING_SOLD_VERIFICATION", "SOLD"].includes(status) },
    { key: "admin", label: "Admin Approved", ok: ["PUBLISHED", "BOOKED", "SOLD"].includes(status) },
  ];
}

/** Purpose: normalize property lifecycle values in one place before UI checks. */
export function propertyStatus(status) {
  return String(status || "").toUpperCase();
}

/** Purpose: SOLD is final; buyers should see it only on detail/history/saved pages. */
export function isSoldStatus(status) {
  return propertyStatus(status) === "SOLD";
}

/** Purpose: office/agent/owner requested SOLD, but admin has not verified yet. */
export function isPendingSoldStatus(status) {
  return propertyStatus(status) === "PENDING_SOLD_VERIFICATION";
}

/** Purpose: buyer contact/booking buttons must be disabled for these statuses. */
export function buyerUnavailableReason(status) {
  const s = propertyStatus(status);
  if (s === "SOLD") return "This property is sold and no longer available.";
  if (s === "PENDING_SOLD_VERIFICATION") return "This property is under sold verification and is not available.";
  if (s === "BOOKED") return "This property is already booked.";
  return "";
}

/** Purpose: internal users can request SOLD only from active/closeable statuses. */
export function canMarkSoldStatus(status) {
  return ["PUBLISHED", "BOOKED", "VERIFIED"].includes(propertyStatus(status));
}

export function statusTone(status) {
  const s = propertyStatus(status);
  if (["PUBLISHED", "VERIFIED"].includes(s)) return "emerald";
  if (["PENDING_VERIFICATION", "PENDING_SOLD_VERIFICATION", "UNDER_NEGOTIATION", "BOOKED"].includes(s)) return "amber";
  if (["REJECTED", "ARCHIVED"].includes(s)) return "rose";
  if (s === "SOLD") return "slate";
  return "slate";
}
